import { Question } from '../Question'

export const QrProposals = ({ question }: { question: Question }) => null
